import React, {useMemo} from 'react';
import type {DataFormConfiguration} from 'schema/types';
import type {ExpressionV4} from 'services/metadata/types';
import {useLocalization} from 'localization';
import {CustomAgentActions} from '../components/CustomAgentActions';

export const useExpressionFormConfiguration = () => {
  const {t} = useLocalization();

  return useMemo(
    (): Partial<DataFormConfiguration<ExpressionV4>> => ({
      schemaContainers: {},
      showWhenReadonlyAndEmpty: true,
      parts: {
        agents: {
          label: t('form.global.field.agents.label'),
          renderCustomListActions: (part, props) => (
            <CustomAgentActions part={part} {...props} />
          ),
        },
      },
    }),
    [t],
  );
};
